import { Component,  Inject, OnInit,  ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";
import { IBusinessView } from "app/models/business/business";
import { BusinessService } from "app/services/business/business.service";
import { ReportsService } from "app/services/reports/reports.service";

@Component({
  selector: 'business-exemptBusinessList',
  templateUrl: './exemptBusinessList.component.html',
  styleUrls: ['./exemptBusinessList.component.scss']
})

export class ExemptBusinessListComponent implements OnInit {

  list: IBusinessView[] = [];
  listCount: number = 0;
  filter: string = '';
  selectedViolations: string[] = [];
  showList: boolean = true;
  businessId: number = 0;

  displayedColumns: string[] = ['businessName', 'businessAddress1', 'exemptType', 'exemptCertificateDate', 'exemptStatus',
    'active'];
  dataSource = new MatTableDataSource<IBusinessView>(this.list);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private reportService: ReportsService,
    private dialogRef: MatDialogRef<ExemptBusinessListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
    this.getData();
    this.dataSource.data = this.list;
    this.businessId = 0;
  }

  getData() {
    this.reportService.getExemptBusinessesData().subscribe({
      next: response => {
        this.list = response;
        this.dataSource.data = this.list;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      // this.list = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Data");
      },
    });
  }

  gotoBusiness(businessId: number) {
    this.businessService.businessId = businessId;
    this.businessService.businessTab = 0;
    this.sharedService.doRedirect('business/business');
    // this.businessId = businessId;
    this.return();
  }

  return(): void {
    this.dialogRef.close(this.businessId);
  }

}